import React, { useMemo, useState } from "react";

import moment from "moment";
import FootprintDatePicker from "../../../Components/utils/FootprintDatePicker";
import { DEFAULT_FORMAT } from "../../../Components/utils/FootprintDatePicker";
import FootprintInputText from "../../../Components/utils/FootprintInputText";
import FootprintButton from "../../../Components/utils/FootprintInputButton";
import FootprintInputRadio from "../../../Components/utils/FootprintInputRadio";
import Survey from "../../Survey/component/Survey1";

import { useAtom } from "jotai";
import { activeChildDetail, appConstants } from "../../../AtomStore/store";
import { useRequestProcessor } from "../../../requestProcessor";

import { useNavigate } from "react-router-dom";
import { handleWithdrawChild } from "../../../QueryFunctions/queryfunction";
import SpinnerLoading from "../../../Components/utils/SpinnerLoading";
const WithdrawChild = () => {
  const { useMutationWrapper } = useRequestProcessor();

  const navigate = useNavigate();
  const [activeChild] = useAtom(activeChildDetail);

  const [constants] = useAtom(appConstants);
  const [state, setState] = useState({
    isOpen: false,
    //withdrawDate: undefined,
    reason: undefined,
    otherRemark: undefined,
    rating: undefined,
    tags: undefined,
    comment: undefined,
    withdrawDate: undefined,
    error: undefined,
  });

  useMemo(() => {
    console.log(
      "[Withdraw Child] Initializing withdraw child form  for child:",
      activeChild?.id
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const withdrawChild = useMutationWrapper(
    ["withdrawChild", "withdraw" + activeChild?.id],
    () => {
      console.log("[Withdraw Child] Calling API: /parentapp/request ", state);

      return handleWithdrawChild(state, navigate);
    },
    {
      onSuccess: (data) => {
        console.log("[Withdraw Child] withdraw child request response:", data);
      },
    }
  );

  const validate = () => {
    if (state.holidaySelected === true) {
      setState({ ...state, error: "The Selected Date Cannot Be A Holiday" });
      return false;
    } else if (state.withdrawDate === undefined) {
      setState({ ...state, error: "Please Select Date Of Withdraw" });
      return false;
    } else if (state.reason === undefined) {
      setState({ ...state, error: "Please Select Reason" });
      return false;
    } else if (state.reason === "Others" && state.otherRemark === undefined) {
      setState({ ...state, error: "Please Enter Reason In Case Of Other" });
      return false;
    } else if (state.rating === undefined) {
      setState({ ...state, error: "Please Select Rating" });
      return false;
    } else if (state.tags === undefined || state.tags.length === 0) {
      setState({ ...state, error: "Please Check The Tags" });
      return false;
    } else if (state.comment === undefined) {
      setState({ ...state, error: "Please Enter Comment" });
      return false;
    } else {
      return true;
    }
  };

  console.log("State", state);

  const submit = (type) => {
    if (validate()) {
      // this.props.showPasswordOverlay(true, (isMatched) => {
      withdrawChild.mutate();
    } else {
    }
    //   });
    // }
  };
  return (
    <div className="m-[10px] mt-[20px]">
      {withdrawChild.isLoading && <SpinnerLoading />}

      <div className="bg-white rounded shadow p-2 pb-4 ">
        <div className="md:p-2">
          <form className="space-y-4">
            {/* Withdraw Date */}
            <div>
              <label
                htmlFor="startDate"
                className="block text-sm font-medium text-black mb-1"
              >
                Withdraw Date
              </label>
              <div className="flex items-center">
                <FootprintDatePicker
                  holidaySelected={(selected) =>
                    setState({
                      ...state,
                      error: "The selected Date Cannot Be a Holiday",
                      holidaySelected: selected,
                    })
                  }
                  inputProps={{ placeholder: "Select Date" }}
                  minimumDate={moment().subtract(1, "days")}
                  onChange={(date) =>
                    setState({
                      ...state,
                      holidaySelected: false,
                      withdrawDate: moment(date).format(DEFAULT_FORMAT),
                      error: undefined,
                    })
                  }
                />
                <i className="icon-calender text-2xl text-black  mr-2" />
              </div>
            </div>
            <hr className="  bg-black" />

            {/* Reason Options */}
            <div>
              <p className="text-sm font-medium text-black mb-2">
                Reason Option
              </p>
              <div className="space-y-2 pl-4">
                {Array.isArray(constants?.WithdrawReason)
                  ? constants.WithdrawReason.map((item, i) => (
                      <div key={i} className="flex items-center">
                        <FootprintInputRadio
                          className="mr-2"
                          label={item}
                          value={item}
                          name="customRadio"
                          id={i}
                          onClick={(value) =>
                            setState({
                              ...state,
                              reason: value,
                              error: undefined,
                            })
                          }
                        />
                        <span className="text-sm">{item}</span>
                      </div>
                    ))
                  : null}
              </div>
            </div>

            {/* Additional Text Input for 'Others' */}
            {state.reason === "Others" && (
              <div>
                <label
                  htmlFor="exampleText"
                  className="block text-sm font-medium text-black mb-1"
                >
                  Reason
                </label>
                <FootprintInputText
                  type="text"
                  name="text"
                  id="exampleText"
                  onChange={(value) =>
                    setState({
                      ...state,
                      otherRemark: value,
                      error: undefined,
                    })
                  }
                />
              </div>
            )}
            <hr className="  bg-black" />

            {/* Survey Section */}
            <Survey
              onRatingPressed={(rating) =>
                setState({ ...state, rating, error: undefined })
              }
              getComment={(comment) =>
                setState({ ...state, comment, error: undefined })
              }
              getTags={(answers) =>
                setState({
                  ...state,
                  tags: answers.filter((item) => item.checked === true),
                  error: undefined,
                })
              }
            />

            {/* Error Message */}
            {state.error && (
              <p className="text-red-600 text-sm font-medium">{state.error}</p>
            )}

            {/* Submit Button */}
            <div className="text-center">
              <FootprintButton
                className="bg-blue-600 hover:bg-blue-700 text-white font-semibold py-2 px-4 rounded"
                onClick={() => submit()}
              />
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default WithdrawChild;
